import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Window from '@lib/window-size';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  drawer_content,
  poi_container,
  marker_control_container,
  toggles,
  is_open,
  section_header,
  marker_count,
  legend_container,
  apply_button
} = styles;

// ---------------------------------------------------------

import Toggle from '@components/toggle';
import RadioButton from '@components/radio-button';
import Button from '@components/button';
import Icon from '@components/icon';

// ---------------------------------------------------------

const Drawer = ({
  isOpen,
  mapOptionsCallback,
  markerOptionsCallback,
  markerCount,
  mobileModalisOpen,
  initialMarkerOptions,
  initialMapOptions
}) => {
  const isMobile = Window().width <= 720;

  const [markerOption, setMarkerOption] = useState(initialMarkerOptions || 'currentProperty');

  const [showOffices, setShowOffices] = useState(initialMapOptions.offices);
  const [showPoi, setShowPoi] = useState(initialMapOptions.poi);

  const setDisplayOptions = (option) => {
    markerOptionsCallback(option);
    setMarkerOption(option);
  };

  return (
    <div className={classNames(drawer_content, { [is_open]: isOpen })}>
      <h3>Map Options</h3>
      {markerOption !== 'currentProperty' && (
        <span className={marker_count}>
          {markerCount > 0 ? `${markerCount} nearby listings` : 'No nearby listings'}
        </span>
      )}
      <div className={marker_control_container}>
        <span className={section_header}>Display Options</span>
        <RadioButton
          items={[
            {
              label: 'Current Property Only',
              value: 'currentProperty'
            },
            {
              label: 'Nearby Listings',
              value: 'nearbyProperties'
            },
            {
              label: 'Recently Sold',
              value: 'nearbySoldProperties'
            }
          ]}
          selection={markerOption}
          onChange={setDisplayOptions}
          isVertical
        ></RadioButton>
      </div>
      <div className={poi_container}>
        <span className={section_header}>Additional Options</span>
        <div className={toggles}>
          <Toggle
            label="Offices"
            isToggledCallback={(bool) => {
              setShowOffices(bool);
              mapOptionsCallback({
                offices: bool,
                poi: showPoi
              });
            }}
            checkedOnDefault={initialMapOptions.offices}
          ></Toggle>

          <Toggle
            label="Points of Interest"
            isToggledCallback={(bool) => {
              setShowPoi(bool);
              mapOptionsCallback({
                offices: showOffices,
                poi: bool
              });
            }}
            checkedOnDefault={initialMapOptions.poi}
          ></Toggle>
        </div>
      </div>
      <div className={legend_container}>
        <span className={section_header}>Legend</span>
        <div>
          <Icon type="map" name="house" />
          Current Property
        </div>
        <div>
          <Icon type="map" name="office-marker" />
          Office
        </div>
      </div>
      {isMobile && (
        <Button
          className={apply_button}
          label="Apply Filters"
          onClick={() => mobileModalisOpen(false)}
        />
      )}
    </div>
  );
};

Drawer.propTypes = {
  /**
   * Specifies the initial mapOptions
   */
  initialMapOptions: PropTypes.string,

  /**
   * Specifies the initial markerOptions
   */
  initialMarkerOptions: PropTypes.string,

  /**
   * Specifies if the drawer is open
   */
  isOpen: PropTypes.bool,

  /**
   * Specifies the map options
   */
  mapOptionsCallback: PropTypes.func,

  /**
   * Specifies if the of markers on the map
   */
  markerCount: PropTypes.number,

  /**
   * Specifies the markerOptions
   */
  markerOptionsCallback: PropTypes.func,

  /**
   * Closes the mobile modal
   */
  mobileModalisOpen: PropTypes.func
};

export default Drawer;
